__turbopack_context__.v({
  "Actions": "xAmeZq_Actions",
  "Avatar": "xAmeZq_Avatar",
  "Avatars": "xAmeZq_Avatars",
  "Card": "xAmeZq_Card",
  "CurrentCompany": "xAmeZq_CurrentCompany",
  "Details": "xAmeZq_Details",
  "Footer": "xAmeZq_Footer",
  "Header": "xAmeZq_Header",
  "HeaderAndDetails": "xAmeZq_HeaderAndDetails",
  "HighchartsWrapper": "xAmeZq_HighchartsWrapper",
  "Link": "xAmeZq_Link",
  "Loading": "xAmeZq_Loading",
  "LoadingText": "xAmeZq_LoadingText",
  "Ownership": "xAmeZq_Ownership",
  "OwnershipIcon": "xAmeZq_OwnershipIcon",
  "OwnershipText": "xAmeZq_OwnershipText",
  "Percent": "xAmeZq_Percent",
  "PercentExport": "xAmeZq_PercentExport",
  "PersonCard": "xAmeZq_PersonCard",
  "PersonImage": "xAmeZq_PersonImage",
  "PersonImageWrap": "xAmeZq_PersonImageWrap",
  "PersonKeyRole": "xAmeZq_PersonKeyRole",
  "Root": "xAmeZq_Root",
  "SelectedCompanyName": "xAmeZq_SelectedCompanyName",
  "Title": "xAmeZq_Title",
  "Toolbar": "xAmeZq_Toolbar",
  "Wrap": "xAmeZq_Wrap",
  "skeleton-loading": "xAmeZq_skeleton-loading",
});
